import { getAppStore } from '@/store';
import isAuthorized from '@/utils/user/isAuthorized';

/**
 * The signed-in user's spendable credits (subscription + add-on), read from
 * the store the SDK credits subscription keeps current — no request. `null`
 * for a guest and before the first balance lands, which must not read as 0.
 */
const getCreditsBalance = (): number | null => {
  if (!isAuthorized()) return null;
  const { creditsInfo } = getAppStore();
  if (typeof creditsInfo?.credits !== 'number') return null;
  return creditsInfo.credits + (creditsInfo.addonCredits ?? 0);
};

export default getCreditsBalance;
